export enum PrizeTypeEnum {
  SFT = 'SFT',
  NFT = 'NFT'
}
